import React from "react";

// Individual exports
export enum AppBarMenuIndex {
    Home = 0,
    Lesson = 1,
    CustomSentence = 2,
    Leaderboard = 3,
    Conversation = 4,
    OfficeHour = 5,
    Registration = 6,
    Settings = 7,
}


interface IAppBarContextType {
    menuIndex: AppBarMenuIndex;
    setMenuIndex: (menuIndex: AppBarMenuIndex) => void;
    errorMessage: string;
    setErrorMessage: (newErrorMessage: string) => void;
    isLoggedIn: boolean;
    setIsLoggedIn: (isLoggedIn: boolean) => void;
};

const AppBarInitialContext = {
    menuIndex: AppBarMenuIndex.Home,
    setMenuIndex: () => null,
    errorMessage: "",
    setErrorMessage: () => null,
    isLoggedIn: false,
    setIsLoggedIn: () => null
};

const AppBarIndexContext = React.createContext<IAppBarContextType>(AppBarInitialContext);
export default AppBarIndexContext;


export const AppBarProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    const [menuIndex, setMenuIndex] = React.useState(AppBarInitialContext.menuIndex);
    const [errorMessage, setErrorMessage] = React.useState(AppBarInitialContext.errorMessage);
    const [isLoggedIn, setIsLoggedIn] = React.useState(AppBarInitialContext.isLoggedIn);

    const contextValue = React.useMemo(() => ({
        menuIndex: menuIndex,
        setMenuIndex: setMenuIndex,
        errorMessage,
        setErrorMessage,
        isLoggedIn,
        setIsLoggedIn,
    }), [menuIndex, errorMessage, isLoggedIn]);

    return (
        <AppBarIndexContext.Provider value={contextValue}>
            {children}
        </AppBarIndexContext.Provider>
    );
};
